export default "__VITE_ASSET__CR5Lo57j__"